import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { registerServiceWorker, checkInstallability } from './registerServiceWorker';
import { setupNotificationTriggers } from './lib/notificationTriggers';
import { initOneSignal } from './lib/onesignal';

// Polyfills
import { Buffer } from 'buffer';
window.Buffer = Buffer;

// Register service worker for PWA support
registerServiceWorker();

// Check if the app can be installed
checkInstallability();

// Initialize OneSignal for push notifications
initOneSignal();

// Setup notification triggers
setupNotificationTriggers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);